import { Typography } from "antd";
import type { TourStepConfig } from "../types";

export const supportTourSteps: TourStepConfig[] = [
  {
    title: "Поддержка в один клик",
    description: (
      <>
        <Typography.Paragraph>Нажмите эту кнопку, чтобы написать в поддержку.</Typography.Paragraph>
        <Typography.Paragraph type="secondary">
          Ваше сообщение автоматически создаст обращение и передаст его администратору.
        </Typography.Paragraph>
      </>
    ),
    tourTargetId: "support-float-button",
    placement: "leftTop",
  },
  {
    title: "Отслеживайте обращения",
    description:
      "В разделе «Поддержка» собраны все ваши обращения. " +
      "Вы видите статус, историю переписки и можете продолжить диалог.",
    tourTargetId: "nav-support",
    placement: "right",
  },
  {
    title: "Поддержка и в Telegram",
    description:
      "Если вы подключили Telegram-бот — пишите в поддержку прямо из мессенджера. " +
      "Все сообщения синхронизируются: ответы приходят и в систему, и в Telegram.",
    placement: "center",
  },
];
